import { render, staticRenderFns } from "./Collapsible.vue?vue&type=template&id=545f03a3&scoped=true&"
import script from "./Collapsible.vue?vue&type=script&lang=js&"
export * from "./Collapsible.vue?vue&type=script&lang=js&"
import style0 from "./Collapsible.vue?vue&type=style&index=0&id=545f03a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545f03a3",
  null
  
)

export default component.exports